import { Column, Entity, Index } from 'typeorm';
import { BaseEntity } from './base.entity';

/**
 * PD-16364 — a person an administrator chose to leave off every team (a
 * customer-service rep who is the rep on a few accounts, a Workd seat), so the
 * Teams page's Unassigned view stops listing them. Un-ignoring soft-deletes
 * the row; ignoring again recovers it.
 */
@Index('idx_team_unassigned_ignore_user', ['fkUserId'], { unique: true })
@Entity('team_unassigned_ignore')
export class TeamUnassignedIgnoreEntity extends BaseEntity {
	/** Tenant-local `user._id`. */
	@Column('int', { name: 'fk_user__id', unsigned: true })
	public fkUserId!: number;
}
